import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {useCurrencyFormatter} from '../../../../../../../commons/hooks/currency'
import {SlideInModal} from '../../slide-in-modal'
import {classes} from './accessibility-mode.st.css'
import {Filters} from './filters'
import {Footer} from './footer'
import {Header} from './header'
import {TicketsCountInfo} from './tickets-count-info'
import {TicketsList} from './tickets-list'
import {AccessibilityModeProps} from './index'

export const AccessibilityMode = ({
  showAccessibilityMode,
  setShowAccessibilityMode,
  onFooterButtonClick,
  placesCount,
  setForcedPopover,
  chooseSeatMode,
  chooseMultipleSeatsMode,
  setAccessibilityToast,
}: AccessibilityModeProps) => {
  const {isMobile} = useEnvironment()
  const {t} = useTranslation()
  const {getTicketPriceText, getFormattedMoney} = useCurrencyFormatter()

  if (isMobile) {
    return (
      <div className={classes.mobileContainer} data-hook={DH.SEATING_ACCESSIBILITY_MODE}>
        <Filters t={t} getFormattedMoney={getFormattedMoney} getTicketPriceText={getTicketPriceText} />
        {placesCount ? <TicketsCountInfo placesCount={placesCount} /> : null}
        <TicketsList showAccessibilityMode={true} />
        <Footer onButtonClick={onFooterButtonClick} />
      </div>
    )
  }

  const onBackClick = () => {
    setAccessibilityToast(false)
    setShowAccessibilityMode(false)
  }

  return (
    <SlideInModal
      id="accessibility-mode"
      dataHook={DH.SEATING_ACCESSIBILITY_MODE}
      show={showAccessibilityMode}
      backButtonText={t('seatings_closeTicketList')}
      onBackClick={onBackClick}
    >
      <Header />
      <Filters t={t} getFormattedMoney={getFormattedMoney} getTicketPriceText={getTicketPriceText} />
      {placesCount ? <TicketsCountInfo placesCount={placesCount} /> : null}
      <TicketsList setForcedPopover={setForcedPopover} showAccessibilityMode={true} />
      {!chooseSeatMode && !chooseMultipleSeatsMode ? <Footer /> : null}
    </SlideInModal>
  )
}
